import { atom } from 'jotai';

export const neLonAtom = atom<number>(0);
export const neLatAtom = atom<number>(0);
export const swLonAtom = atom<number>(0);
export const swLatAtom = atom<number>(0);
export const userLatAtom = atom<number>(0);
export const userLonAtom = atom<number>(0);

export const queryAtom = atom<string|undefined>();

export const isMyShopAtom = atom<boolean>(false);

export const userLatLonAtom = atom<{
    lat: number,
    lon: number
}>({
    lat: 0,
    lon: 0,
});

export const locationAgreedAtom = atom<boolean>(false);
